import React from 'react';
import { Link } from 'react-router-dom';
import type { Article } from '../types/content';
type JournalCardProps = {
  article: Article;
  layout?: 'stack' | 'row';
};
export function JournalCard({
  article,
  layout = 'stack'
}: JournalCardProps) {
  const row = layout === 'row';
  return <article className={`group relative ${row ? 'grid grid-cols-[minmax(0,2fr)_minmax(0,3fr)] items-center gap-5' : 'flex h-full flex-col'}`} data-id="element-276" data-mp="1v31ev5coupel">
      <div className="overflow-hidden bg-stone" data-id="element-277" data-mp="xgc68cnhdejr">
        <img src={article.image} alt={article.imageAlt} loading="lazy" className={`w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03] ${row ? 'aspect-[4/3]' : 'aspect-[3/2]'}`} data-id="element-278" data-mp="12dkm26l5p6hu" />
      </div>
      <div className={row ? '' : 'mt-5 flex flex-1 flex-col'} data-id="element-279" data-mp="1c5gplx60hotg">
        <p className="t-label text-[0.62rem] text-gold-deep" data-id="element-280" data-mp="engifz7yx6qu">{article.category}</p>
        <h3 className={`mt-2 font-normal leading-snug text-charcoal ${row ? 'text-[clamp(1.05rem,0.95rem+0.3vw,1.3rem)]' : 't-h3'}`} data-id="element-281" data-mp="jmb2t5ll33d2">
          <Link to={`/journal/${article.slug}`} className="after:absolute after:inset-0 group-hover:underline group-hover:underline-offset-4" data-id="element-282" data-mp="2wsppt88khzfh">
            {article.title}
          </Link>
        </h3>
        {!row && <p className="mt-3 text-graphite" data-id="element-283" data-mp="2n1lag7ezcck4">{article.excerpt}</p>}
        <p className={`text-sm text-graphite ${row ? 'mt-2' : 'mt-auto pt-4'}`} data-id="element-284" data-mp="2j1b4gur6tm59">{article.readTime}</p>
      </div>
    </article>;
}